RivalIQ.apps.Favorites.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Picker = Marionette.Dashboard.views.ItemView.mixin({
        template: '#favoritesPickerTemplate',

        mixins: {
            Props: Marionette.Dashboard.mixins.Props
        },

        events: {
            'click .picker-btn': 'onPick'
        },

        onRenderLoaded: function () {
            const me = this;

            me.$('[data-toggle=popover]').popover({
                animation: false,
                html: true,
                trigger: 'manual'
            })
                .on('mouseenter', function () {
                    const el = this;
                    $(el).popover('show');
                    $('.popover').on('mouseleave', function () {
                        $(el).popover('hide');
                    });
                })
                .on('mouseleave', function () {
                    const el = this;
                    setTimeout(function () {
                        if (!$('.popover:hover').length) {
                            $(el).popover('hide');
                        }
                    }, 100);
                });
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();
            const widgetTypes = me.getProp('widgetTypes');
            const deferred = _.reduce(widgetTypes, function (memo, widgetType) {
                return _.reduce(widgetType.groups, function (mem, config) {
                    return _.reduce(config.items, function (m, widget) {
                        const Widget = Marionette.Dashboard.widgets.get(widget.widgetId);

                        if (!props.source && _.get(widget, ['defaultProps', 'source'])) {
                            props.source = widget.defaultProps.source;
                        }

                        if (_.isFunction(Widget.prepare)) {
                            return m.concat(
                                Widget.prepare(props).then(function (state) {
                                    _.set(me, ['_widgetState', widget.widgetId], state);
                                })
                            );
                        }

                        return m;
                    }, mem);
                }, memo);
            }, []);

            return $.when.apply(me, deferred);
        },

        onPick: function (e) {
            const me = this;
            const data = $(e.currentTarget).data();
            const path = me.dashboardModel.router.resolveCurationRoute(
                RivalIQ.enums.curation.DASHBOARDS_BUILDER,
                {
                    configurationId: me.getProp('configurationId'),
                    widgetGroupId: data.widgetGroupId,
                    focusWidgetId: data.focusWidgetId
                }
            );

            RivalIQ.execute('history:navigate', path, {
                trigger: true
            });
        },

        serializeData: function () {
            const me = this;
            return _.defaults({
                widgetTypes: me.getProp('widgetTypes')
            }, me.dashboardModel.customDashboardConfiguration.toJSON());
        },

        getWidgetRenderState: function (widgetId) {
            const me = this;

            const type = RivalIQ.apps.Favorites.data.chartTypes[widgetId];
            if (_.isFunction(type.getPickerRenderState)) {
                const state = _.get(me, ['_widgetState', widgetId]);
                return type.getPickerRenderState(state, me.dashboardModel);
            }

            return {};
        },

        templateHelpers: function () {
            const me = this;
            return {
                isGroupHidden: function (group) {
                    if (!_.isEmpty(group.applicableBetas)) {
                        const isInApplicableBeta = _.some(group.applicableBetas, function (beta) {
                            return RivalIQ.state.account.inBeta(beta);
                        });
                        if (!isInApplicableBeta) {
                            return true;
                        }
                    }

                    const source = _.get(group, ['source']);
                    if (!_.isFinite(source)) {
                        return false;
                    }
                    const sourceMask = RivalIQ.enums.sourceDetails[source].sourceMask;
                    const supportedSources = RivalIQ.state.plan.get('supported_sources');
                    return ((supportedSources & sourceMask) !== sourceMask);
                },
                getWidgetDescription: function (widget) {
                    const renderState = me.getWidgetRenderState(widget.widgetId);
                    return _.get(renderState, ['description'], widget.builderDescription);
                },
                getWidgetClassName: function (widgetId) {
                    const renderState = me.getWidgetRenderState(widgetId);
                    return _.get(renderState, ['className']);
                }
            };
        }
    });

    function loadCustomDashboardConfiguration(curation) {
        const configuration = new App.models.Configuration({
            id: curation.getProp('configurationId'),
            curation_id: RivalIQ.enums.curation.DASHBOARDS,
            landscape_id: curation.getProp('landscapeId'),
            account_id: curation.getProp('account_id')
        });

        return configuration.fetch()
            .then(function () {
                curation.customDashboardConfiguration = configuration;
            });
    }

    curations.Picker = RivalIQ.apps.Dashboard.models.Curation.extend({
        beforeFilters: [
            loadCustomDashboardConfiguration
        ],

        title: function () {
            return RivalIQ.strings.favorites_builder_widget_picker_title;
        },

        timePeriod: false,
        companySets: false,

        widgetsView: Picker,

        getViewTrackingOptions: function () {
            const me = this;
            const options = RivalIQ.apps.Dashboard.models.Curation.prototype.getViewTrackingOptions.apply(me, arguments);
            return _.omit(options, 'widgetTypes');
        },

        loadConfiguration: function () {
            const me = this;
            const deferred = new $.Deferred();

            RivalIQ.data.configuration.fetch(me, me.getProps())
                .done(deferred.resolve)
                .fail(function (xhr) {
                    if (xhr.status === 404) {
                        deferred.resolve(App.utils.getDefaultRedirect());
                    } else {
                        deferred.reject(xhr);
                    }
                });

            return deferred;
        }
    });

});
